module.exports = __webpack_public_path__ + "434d6364f29c9e18ba5ff09fb081128c.svg";